// extracted by mini-css-extract-plugin
var _1 = "styles-module__error___p8nol";
var _2 = "styles-module__phone___dPZVZ";
export { _1 as "error", _2 as "phone" }
